import { HTMLAttributes } from 'react';

import styled from '@emotion/styled';
import { theme } from '@revenuemarket/design';

import * as S from './style';

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  color?: string;
}

const Circle = styled(S.Circle)<{ color?: string }>`
  background-color: ${(props) => props.color || theme.colors.teal1000};
`;

export default function Spinner(props: SpinnerProps) {
  return (
    <S.Wrapper {...props}>
      <S.LoadingWrapper>
        <Circle color={props.color} />
        <Circle color={props.color} />
        <Circle color={props.color} />
        <Circle color={props.color} />
        <Circle color={props.color} />
        <Circle color={props.color} />
        <Circle color={props.color} />
        <Circle color={props.color} />
      </S.LoadingWrapper>
    </S.Wrapper>
  );
}
